initModal();

$('[data-close-modal]').on('click', function(){
    const country = $(this).data('country-override');
    closeModal(this, country);
})

function initModal(){
    const modal = document.getElementById('country-dialog');

    if(modal){
        const country = checkCountry();
        const hasSeenModal = Boolean(sessionStorage.getItem('hasSeenModal'));
        const currentPage = window.location.pathname;

        if(currentPage === '/'){
            if(country !== 'canada'){
                if(hasSeenModal === false){
                    openModal();
                    sessionStorage.setItem('hasSeenModal', true);
                } else {
                    window.location.replace("/international");
                }
            } else {
                // User is in canada, and viewing the homepage
            }
        } else {
            if(country === 'canada'){
                if(hasSeenModal === false){
                    openModal();
                    sessionStorage.setItem('hasSeenModal', true);
                } else {
                    window.location.replace("/");
                }
            } else {
                // User is not in canada, and viewing the international page
            }
        }
    }
}

function checkCountry(){
    let country = sessionStorage.getItem('country');

    if(country === null){
        const countryDialog = document.getElementById('country-dialog');
        country = countryDialog.dataset.country;
        sessionStorage.setItem('country', country);
    }

    return country
}

function openModal(){
    openDialog('country-dialog', $('.logo')[0]);
}

function closeModal(el, countryOverride = false){
    if(countryOverride){
        sessionStorage.setItem('country', countryOverride);
    }

    closeDialog(el);
}